import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = style({
  padding: theme.spacings.s2,
  gap: rem(14),
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.colors.secondary,
  color: theme.colors.onSecondary,
  borderRadius: theme.borderRadiuses.s,
  userSelect: "none",
});
